//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import divSpan from '@/components/DivSpan';
export default {
  name: "contract-pay-list",
  components: {
    divSpan
  },
  data() {
    return {
      uploadUrl:process.env.API_ROOT,
      refresh:true,
      wrapperHeight: 0,
      allLoaded: false,
      config: {
        title: '合同验收',
        url: 'api/dynamic-form-value/contract_receive/page',
        property: "dynamicFormValue.id",
        fixRules: [],
        specialCondition: {
          dynamicFormCode: "contract_receive"
        },
        inputCondition: {
          placeholder: '合同编号/名称/供应商/公司名称',
          searchCondition: 'key',
          rules: [{
            field: "field_contract_no-field_contract_id_show-field_supplier_id_show-field_company_id_show",
            option: "LIKE_ANYWHERE"
          }]
        },
      },
      searchData: {},
      contentList: [],
      "cardConfig": {
          "topTitle": {
            "valueField": "field_contract_id_show",
            "name": "流程标题-"
          },
          "status":{
            "valueField":"field_state_show"
          },
          "content": [
            {
              "icon": "icon-supply",
              "name": "合同编号-",
              "valueField": "field_contract_no"
            },
            {
              "icon": "icon-all",
              "name": "创建日期-",
              "valueField": "field_create_date",
              "type":"date"
            }
          ]
        }
    }
  },
  methods: {
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.contentList = this.contentList.concat(e);
        }else{
          this.contentList = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    conversionName(data, name) {
      let retanData = '';
      if (name) {
        let colName = name.split('.');
        if (data.hasOwnProperty(colName[0])) {
          if (colName.length > 1) {
            for (let i = 0; i < colName.length; i++) {
              if (i == 0) {
                retanData = data[colName[0]];
              } else {
                if (retanData != null) {
                  retanData = retanData[colName[i]];
                } else {
                  return retanData = '';
                }
              }
            }
            return retanData == null ? '' : retanData;
          } else {
            return data[colName[0]] == null ? '' : data[colName[0]];
          }
        } else {
          return retanData == null ? '' : retanData;
        }
      } else {
        return retanData == null ? '' : retanData;
      }
    },
    openFlow(e) {
      let baseUrl;
      if(this.$store.state.systemConfig){
        baseUrl = this.$store.state.systemConfig.systemUrl + '#/';
      }else{
        return;
      }
      this.$store.dispatch('commitChangeIframeUrl',`${baseUrl}jy-sso?token=${this.token}&requestId=${e.dynamicFormValue.bizId}&isMobile=1`);
      this.$router.push('dynamic-flow');
    },
  },
  mounted() {
    let tokens = localStorage.getItem('_token');
    if(tokens){
      this.token = tokens.substr(7);
    }
    setTimeout(() => {
      this.init();
      this.$refs.header.getlist();
    },600);
  }
}



// WEBPACK FOOTER //
// ./src/page/dynamic-form-list/contract-receive/contract-receive-list.vue